import api from './api';

export const debtorService = {
  getAll: async (params = {}) => {
    // Filter out undefined values
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined)
    );
    const queryString = new URLSearchParams(filteredParams).toString();
    return await api.get(`/debtors${queryString ? '?' + queryString : ''}`);
  },

  getById: async (debtorId) => {
    return await api.get(`/debtors/${debtorId}`);
  },

  create: async (debtorData) => {
    return await api.post('/debtors', debtorData);
  },

  update: async (debtorId, debtorData) => {
    return await api.put(`/debtors/${debtorId}`, debtorData);
  },

  delete: async (debtorId) => {
    return await api.delete(`/debtors/${debtorId}`);
  }
};
